import { useEffect, useState } from 'react';
import { GraduationCap, BookOpen } from 'lucide-react';

const StatsCard = ({ icon: Icon, label, value, delay = 0, color = 'blue' }) => {
  const [displayValue, setDisplayValue] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger animation after delay
    const timer = setTimeout(() => {
      setIsVisible(true);
      animateValue();
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  const animateValue = () => {
    const duration = 1500; // 1.5 seconds
    const steps = 60;
    const increment = value / steps;
    let current = 0;
    let step = 0;

    const timer = setInterval(() => {
      step++;
      current = Math.min(increment * step, value);
      setDisplayValue(Math.floor(current));
      
      if (step >= steps) {
        setDisplayValue(value);
        clearInterval(timer);
      }
    }, duration / steps);
  };

  const colorClasses = {
    blue: {
      bg: 'from-theme-blue to-blue-600',
      icon: 'text-theme-blue',
      text: 'text-theme-blue'
    },
    yellow: {
      bg: 'from-theme-yellow to-yellow-500',
      icon: 'text-theme-yellow',
      text: 'text-theme-yellow'
    }
  };

  const colors = colorClasses[color] || colorClasses.blue;

  return (
    <div
      className={`relative overflow-hidden bg-gradient-to-br ${colors.bg} rounded-2xl shadow-xl p-6 md:p-8 border-2 border-white/20 transform transition-all duration-500 hover:scale-105 hover:shadow-2xl ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
      }`}
    >
      {/* Overlay sutil */}
      <div className="absolute inset-0 bg-white/10"></div>
      
      {/* Contenido */}
      <div className="relative z-10 flex flex-col items-center">
        <div className="mb-4 bg-white/20 p-3 rounded-full backdrop-blur-sm">
          <Icon className="w-8 h-8 md:w-10 md:h-10 text-white" />
        </div>
        <div className="text-5xl md:text-6xl font-bold mb-3 text-white drop-shadow-lg">
          {displayValue}
        </div>
        <div className="text-white/90 text-sm md:text-base font-semibold text-center uppercase tracking-wide">
          {label}
        </div>
      </div>

      {/* Efecto de brillo */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full hover:translate-x-full transition-transform duration-1000 pointer-events-none"></div>
      
      {/* Decoración circular */}
      <div className="absolute -top-10 -right-10 w-32 h-32 bg-white/10 rounded-full blur-2xl"></div>
      <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-white/10 rounded-full blur-2xl"></div>
    </div>
  );
};

export default StatsCard;

